export default __webpack_public_path__ + "static/media/ios_download_banner.f2bf7c12.png";